<script lang="ts">
	import type { PublicDay } from '../../AppTypes';
	import { statusFill, statusLabel } from '../../statusUtils';

	export let days: PublicDay[] = [];

	const barWidth = 4;
	const gap = 2;
	const height = 34;

	$: width = days.length * (barWidth + gap);
</script>

{#if days.length > 0}
	<svg {width} {height} viewBox={`0 0 ${width} ${height}`} class="w-full" preserveAspectRatio="none">
		{#each days as day, i}
			<rect
				x={i * (barWidth + gap)}
				y="0"
				width={barWidth}
				{height}
				rx="1"
				fill={statusFill(day.status)}
				opacity={day.status === 'unknown' ? 0.4 : 1}
			>
				<title>{day.day}: {statusLabel(day.status)}{day.uptimePercent !== null ? ` (${day.uptimePercent}% uptime)` : ''}</title>
			</rect>
		{/each}
	</svg>
{/if}
